import $ from 'jquery';
import { Foundation } from 'foundation-sites/js/foundation.core';

Foundation.addToJquery($);
